import checkout from "./Form";

const {
  formField: {
    // datas
    number,
		name,
		regional,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // datas
  [number.name]: "",
  [name.name]: "",
  [regional.name]: "",
};